






































import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class SlideBar extends Vue {
 @Prop(Array)
 filemenu!: Array<object>

 @Prop(Array)
 openeds!: Array<string>

 @Prop(String)
 activeindex!: string

 emitActiveMenu (index: string) {
   this.$emit('listenActiveIdx', index)
 }
}
